<template>
  <div class="qsPageBox">
    <div class="qsPage" :class="pActive==2?'phoneView':''">
      <template v-if="!tipsShow">
        <div class="userBox" v-if="uForm.cusName">
          <el-descriptions :column="1">
              <el-descriptions-item :label="Language('客户姓名')">{{uForm.cusName}}</el-descriptions-item>
              <el-descriptions-item :label="Language('电话')">{{uForm.tel}}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="agentBox" v-if="sourceType == 1">
          <el-form ref="form" label-width="80px" size="small">
            <el-form-item :label="Language('外呼状态')">
              <el-select v-model="tForm.status" :placeholder="Language('外呼状态')">
                <el-option :label="Language('呼叫成功')" value="1"></el-option>
                <el-option :label="Language('呼叫失败')" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="Language('外呼内容')">
              <el-input v-model="tForm.content" :placeholder="Language('外呼内容')" type="textarea" :rows="4" maxlength="500"></el-input>
            </el-form-item>
            <el-form-item :label="Language('是否完成')">
              <el-radio-group v-model="recordStatus">
                <el-radio label="1">{{Language('是')}}</el-radio>
                <el-radio label="0">{{Language('否')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="Language('完成说明')">
              <el-input v-model="reason" :placeholder="Language('完成说明')" type="textarea" :rows="4" maxlength="500"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!--呼叫成功时才显示问卷填写-->
        <template v-if="tForm.status == 1">
          <h1>{{qsForm.qsName}}</h1>
          <div class="guideCnt" v-if="qsForm.guideCnt">{{qsForm.guideCnt}}</div>
          <div class="qsBox">
            <template v-for="(item, index) in qsList">
              <div class="qsItem" :key="index" :id="'qs_' + item.id" v-show="item.relShow && item.jumpShow && (qsForm.isOneQ == 0 || item.id == tId)">
                <div class="qsTitle">
                  <span class="red fl" v-if="item.isRequired == 1">*</span>
                  <span class="fl">{{index+1}}.</span>
                  <span class="fl moreType" v-if="item.qType == 4">[{{Language('多选题')}}]</span>
                  <div v-html="reSubject(item.subject)"></div>
                </div>
                <div class="qsContent">
                  <el-row>
                    <!--简答题-->
                    <template v-if="item.qType == 1">
                      <el-col :span="24">
                        <el-input v-model.trim="item.answer" type="textarea" :rows="6" :placeholder="Language('请填写内容')" class="mt-15" @blur="jumpRelFn(item, index)"></el-input>
                      </el-col>
                    </template>

                    <!--单选题-->
                    <template v-if="item.qType == 2">
                      <el-radio-group v-model="item.answer" @change="jumpRelFn(item, index)">
                        <template v-for="(itemOpt, indexO) in item.optData">
                          <el-col :span="reColFn(item.colQty)" :key="indexO">
                            <div class="qsContent-item">
                              <el-radio :label="itemOpt.optName">{{itemOpt.optName}}</el-radio>
                              <span class="red font-14 mr-5" v-if="itemOpt.isRequired == 1 && item.answer == itemOpt.optName">*</span>
                              <el-input v-model="itemOpt.blankCnt" placeholder="" :id="'opt_' + itemOpt.id" size="small" style="width: 300px;" v-if="itemOpt.isFillblank == 1 && item.answer == itemOpt.optName" @blur="clearRedFn(itemOpt.blankCnt, itemOpt.id)"></el-input>
                            </div>
                          </el-col>
                        </template>
                      </el-radio-group>
                    </template>
                    <!--多选题-->
                    <template v-if="item.qType == 4">
                      <el-checkbox-group v-model="item.answer" @change="jumpRelFn(item, index)">
                        <template v-for="(itemOpt, indexO) in item.optData">
                          <el-col :span="reColFn(item.colQty)" :key="indexO">
                            <div class="qsContent-item">
                              <el-checkbox :label="itemOpt.optName">{{itemOpt.optName}}</el-checkbox>
                              <span class="red font-14 mr-5" v-if="itemOpt.isRequired == 1 && item.answer.includes(itemOpt.optName)">*</span>
                              <el-input v-model="itemOpt.blankCnt" placeholder="" :id="'opt_' + itemOpt.id" size="small" style="width: 300px;" v-if="itemOpt.isFillblank == 1 && item.answer.includes(itemOpt.optName)" @blur="clearRedFn(itemOpt.blankCnt, itemOpt.id)"></el-input>
                            </div>
                          </el-col>
                        </template>
                      </el-checkbox-group>
                    </template>

                    <!--下拉单选题-->
                    <template v-if="item.qType == 3">
                      <el-col :span="24">
                        <el-select v-model="item.answer" placeholder="" class="mt-15 w-100bf" clearable @change="jumpRelFn(item, index)">
                          <el-option v-for="(itemOpt, indexO) in item.optData"
                            :key="indexO"
                            :label="itemOpt.optName"
                            :value="itemOpt.optName">
                            {{itemOpt.optName}}
                          </el-option>
                        </el-select>
                      </el-col>
                    </template>
                  </el-row>
                </div>
              </div>
            </template>
            <div class="qsBottom">
              <el-button type="primary" size="medium" v-if="(qsForm.isOneQ == 0 || (tId && tId == qsList[qsList.length - 1].id)) && view != 1" @click="useApiSaveInfoFn" :disabled="!lock">{{Language('提交')}}</el-button>
              <template v-else-if="qsForm.isOneQ == 1">
                <el-button type="info" size="medium" v-if="tId && tId != qsList[0].id" @click="prevQsFn">{{Language('上一题')}}</el-button>
                <el-button type="primary" size="medium" @click="nextQsFn">{{Language('下一题')}}</el-button>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="qsBottom">
            <el-button type="primary" size="medium" v-if="view != 1" @click="useApiSaveInfoFn" :disabled="!lock">{{Language('提交')}}</el-button>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="tips" v-html="qsForm.tipsContent"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { 
  useApiGetInfo, useApiGetQuestionList, useApiSaveInfo, useApiGetInfo4App, useApiGetQuestionList4App
} from "../../http/Questionnaire.js";
import { getTimes } from "../../components/Common/datetime.js";

export default {
  name: "qsPage",
  components: {},
  data() {
    return {
      vdnId: '',
      qsId: '', //问卷id
      qsForm: {}, //问卷信息
      qsList: [], //题目信息
      tForm: { //外拨任务信息
        taskDetId: '', //任务明细id
        taskId: '', //任务id
        status: '1', //外拨状态 0.未呼出 1.已呼出 2.呼叫失败 3.超时取消 4.取消
        popupType: '', //外呼弹屏类型
        content: '', //外呼内容，坐席录入
        callPid: '', //通话PID
      },
      uForm: { //客户信息
        cusId: '', //客户ID
        cusName: '', //客户姓名
        tel: '', //电话
      },
      sourceType: '', //问卷来源，0.外发调查 1.回访调查
      sourceId: '', //来源ID
      recordStatus: '1', //是否完成，0.否 1.是
      reason: '', //完成说明 坐席填写
      begDate: '', //答题日期
      tipsShow: false,
      lock: true,
      tId: '', //一题一页时当前在进行回答的题目
      pActive: 1, //1PC端、2移动端区分显示
      view: 0, //传1是预览
      prveIds: [], //每次点击下一题时，往此数组记录答题顺序
    };
  },
  watch: {},
  created() {
    document.title = '问卷调查'
  },
  mounted() {
    this.qsId = this.$route.query.qsId
    this.vdnId = this.$route.query.vdnId
    this.sourceType = this.$route.query.sourceType
    this.sourceId = this.$route.query.sourceId

    this.tForm.taskDetId = this.$route.query.taskDetId
    this.tForm.taskId = this.$route.query.taskId
    this.tForm.popupType = this.$route.query.popupType
    this.tForm.callPid = this.$route.query.pId

    this.uForm.cusId = this.$route.query.cusId
    this.uForm.cusName = this.$route.query.cusName
    this.uForm.tel = this.$route.query.tel

    this.pActive = this.$route.query.pActive

    this.view = this.$route.query.view
    //判断是否移动端
    if(navigator.userAgent.indexOf('iphone') > -1 ||
        navigator.userAgent.indexOf('iPhone') > -1 ||
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('android') > -1){
          this.pActive = 2
    }

    this.useApiGetInfoFn()
  },
  watch: {
    pActive(val){
      if(val == 2){
        this.addMeta('viewport', 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover',);
      }
    }
  },
  methods: {
    //返回列选择
    reColFn(col){
      let val = ['', 24, 12, 8, 6, 25, 4]
      return val[col]
    },
    //问卷信息
    useApiGetInfoFn() {
      let data = {
        qsId: this.qsId,
        vdnId: this.vdnId
      }
      //外部填写
      let apiUrlCall = useApiGetInfo4App
      if(this.view == 1){
        //预览内部查看
        apiUrlCall = useApiGetInfo
      }
      apiUrlCall(data).then((res) => {
        if (res) {
          if (res.retCode == 1) {
            this.qsForm = {
              ...res.data
            }
            this.useApiGetQuestionListFn()
          }
        }
      });
      
    },
    //题目信息
    useApiGetQuestionListFn() {
      let data = {
        qsId: this.qsId,
        vdnId: this.vdnId
      }
      //外部填写
      let apiUrlCall = useApiGetQuestionList4App
      if(this.view == 1){
        //预览内部查看
        apiUrlCall = useApiGetQuestionList
      }
      apiUrlCall(data).then((res) => {
        if (res) {
          if (res.retCode == 1) {
            let _d = res.data
            _d.map((o)=>{
              if(o.qType == 4){
                o.answer = []
                //检查多选题是否有设置默认答案
                o.optData.map((od)=>{
                  if(od.isDefault == 1){
                    o.answer.push(od.optName)
                  }
                })
              }else{
                o.answer = ''
                //检查单选题是否有设置默认答案
                o.optData.map((od)=>{
                  if(od.isDefault == 1){
                    o.answer = od.optName
                  }
                })
              }
              //默认跳题全部展示
              o.jumpShow = true
              //根据题目关联信息显示隐藏
              if(o.relData && o.relData.length > 0){
                o.relShow = false //有关联题目得暂时隐藏
                //关联信息拆分成数组，方便操作
                o.relData.map((r)=>{
                  let cfgArr = []
                  let cfgJson = ''
                  if(r.cfgJson){
                    cfgJson = JSON.parse(r.cfgJson)
                    cfgJson.map((e)=>{
                      cfgArr.push(e.optName)
                    })
                  }
                  r.cfgArr = cfgArr
                })
              }else{
                o.relShow = true //没有的全部显示
              }
              if(o.jumpShow && o.relShow && !this.tId){
                this.tId = o.id
              }
            })
            this.qsList = _d
            // console.log(this.qsList)
          }
        }
      });
    },
    //提交
    useApiSaveInfoFn(){
      let data = {
        vdnId: this.vdnId,
        qsId: this.qsId,
        sourceType: this.sourceType,
        sourceId: this.sourceId,
        recordStatus: this.recordStatus,
        totalScore: 0,
        begDate: getTimes(),
        ...this.tForm,
        ...this.uForm,
        reason: this.reason,
        answerData: []
      }
      //问卷作答情况
      let score = 0
      let answerData = []
      let notRequired = false
      let optRequired = false
      //外呼状态是成功的才记录问卷答案
      if(this.tForm.status == 1){
        this.qsList.map((o)=>{
          //检查题目是否必填
          if(o.isRequired == 1 && (!o.answer || o.answer.length == 0)){
            $('#qs_' + o.id).addClass('qsRed')
            notRequired = true
          }
          if(o.relShow && o.jumpShow){
            let aData = {
              qId: o.id,
              answer: '',
              blankCnt: '',
              score: 0
            }
            if(o.qType == 4){
              //多选题
              if(o.answer && o.answer.length > 0){
                //转字符串保存
                aData.answer = o.answer.join(',')
                let blankCnt = []
                o.optData.map((d)=>{
                  if(o.answer.includes(d.optName)){
                    blankCnt.push(d.blankCnt?d.blankCnt:'')
                    aData.score = aData.score + d.score //分数计算
                    if(d.isFillblank == 1 && d.isRequired == 1 && !d.blankCnt){
                      //选项填写及必填但没有填
                      $('#opt_' + d.id).addClass('optRed')
                      optRequired = true
                    }
                  }
                })
                if(blankCnt.length > 0){
                  aData.blankCnt = JSON.stringify(blankCnt)
                }
              }
            }else{
              //非多选题 - 答案只有一个
              aData.answer = o.answer.trim()
              if(o.qType == 2 || o.qType == 3){
                //是单选题的话，要处理允许填空的值
                o.optData.map((d)=>{
                  if(d.optName == o.answer){
                    aData.blankCnt = d.blankCnt?d.blankCnt:'' //选中项的填空值
                    aData.score = aData.score + d.score //分数计算
                    if(d.isFillblank == 1 && d.isRequired == 1 && !d.blankCnt){
                      //选项填写及必填但没有填
                      $('#opt_' + d.id).addClass('optRed')
                      optRequired = true
                    }
                  }
                })
              }else{
                //简答题，有填写就有分数
                if(aData.answer){
                  aData.score = aData.score + o.score //直接加上本题的分数
                }
              }
            }
            answerData.push(aData)
            score = score + aData.score //计算总分
          }
        })
      }

      //计算分数
      data.totalScore = score
      data.answerData = answerData
      if(optRequired){
        this.$Msg.error('选项填写为必填')
        return false
      }
      if(notRequired){
        this.$Msg.error('题目为必答题的必须作答')
        return false
      }
      this.lock = false
      useApiSaveInfo(data).then((res) => {
        if (res) {
          if (res.retCode == 1) {
            if(this.qsForm.tipsType == 1){
              //显示富文本编辑后的页面样子
              this.tipsShow = true
            }else if(this.qsForm.tipsType == 2){
              //跳转到指定url页面
              window.location.href = this.qsForm.tipsContent
            }else{
              //不配置直接显示提示语
              this.$Msg.success('操作成功');
            }
            setTimeout(()=>{
              //问卷提交成功后，通知呼叫页面进行对应刷新
              top.postMessage({message: 'refreshlist', tipsType: this.qsForm.tipsType}, '*')
            }, 2000)
          }
        }
      });
    },
    //关联题及跳题处理 - 引用题处理
    jumpRelFn(item, index){
      $('#qs_' + item.id).removeClass('qsRed')
      //题目是否显示，是跳题与关联题共同作用的结果
      let answer = item.answer //答案
      let jumpType = item.jumpType //跳题类型
      let jumpId = '' //需要跳转到对应的题目id
      if(jumpType == 2){
        //无条件跳转，直接设置
        jumpId = item.jumpId
      }else if(jumpType == 1){
        //按选项跳转
        item.optData.map((n)=>{
          if(answer == n.optName){
            jumpId = n.jumpId
          }
        })
      }
      this.qsList.map((o, i)=>{
        //检查关联题 - 关联体需要遍历所有题目的答案
        if(o.relData && o.relData.length > 0){
          o.relShow = false
          o.relData.map((r)=>{
            this.qsList.map((q)=>{
              if(r.relactionQId == q.id){
                //多个关联题目统一使用或关系，只有符合其中一种就显示
                if(q.qType == 1){
                  //关联简答题，不需要检查选项
                  o.relShow = true
                }else if(q.qType == 2 || q.qType == 3){
                  //单选题，检查选项是否符合
                  if(r.cfgArr.includes(q.answer)){
                    //所选答案符合关联条件
                    o.relShow = true
                  }
                }else{
                  //多选题，answer也是多个
                  q.answer.map((a)=>{
                    if(r.cfgArr.includes(a)){
                      o.relShow = true
                    }
                  })
                }
              }
            })
          })
        }
        if(i > index){
          o.jumpShow = true
          if(jumpId){
            //操作跳转 - 跳转的题目都是本题后的题目
            if(o.id != jumpId){
              o.jumpShow = false //隐藏
            }else{
              //循环到目标题目时，打后的题目不用再匹配检查了，把跳转id清空
              jumpId = ''
            }
          }
        }
        //检查题目里面的引用情况，只有单选题和下拉选择题才会被引用
        if(item.qType == 2 || item.qType == 3){
          $('.q_span[data-id="'+ item.id +'"]').text(item.answer)
        }
      })
    },
    //匹配正则引用题
    rexFn(html){
      let arr = []
      var re = /\${[^\}]+\}/g
      arr = html.match(re)
      return arr
    },
    //点击上一题
    prevQsFn(){
      if(this.prveIds && this.prveIds.length > 0){
        //有记录题目的答题轨迹才能返回上一题
        this.tId = this.prveIds[this.prveIds.length - 1]
        this.prveIds.splice(this.prveIds.length - 1, 1)
      }else{
        this.$Msg.error('没有上一题了')
      }
    },
    //点击下一题
    nextQsFn(){
      let oldId = this.tId
      let cs = false //设置检查标记
      let notRequired = false
      let optRequired = false
      for(var i = 0; i < this.qsList.length; i++){
        let _t = this.qsList[i]
        if(_t.id == oldId && this.view != 1){ //只检查当前题目，并且是非预览模式
          //必填的题目没有填，提示
          if(_t.isRequired == 1 && (!_t.answer || _t.answer.length == 0)){
            $('#qs_' + _t.id).addClass('qsRed')
            notRequired = true
            break
          }
          //必填的选项没有填，提示
          if(_t.qType == 4){
            //多选题
            if(_t.answer && _t.answer.length > 0){
              _t.optData.map((d)=>{
                if(_t.answer.includes(d.optName)){
                  if(d.isFillblank == 1 && d.isRequired == 1 && !d.blankCnt){
                    //选项填写及必填但没有填
                    $('#opt_' + d.id).addClass('optRed')
                    optRequired = true
                  }
                }
              })
            }
          }else if(_t.qType == 2){
            //单选题
            _t.optData.map((d)=>{
              if(d.optName == _t.answer){
                if(d.isFillblank == 1 && d.isRequired == 1 && !d.blankCnt){
                  //选项填写及必填但没有填
                  $('#opt_' + d.id).addClass('optRed')
                  optRequired = true
                }
              }
            })
          }
        }

        if(optRequired){
          break;
        }
        if(cs && _t.jumpShow && _t.relShow){
          //后续的下一题如果能正常显示的话，跳转到该下一题
          this.tId = _t.id
          break
        }
        if(this.tId == _t.id){
          cs = true
        }
      }
      if(optRequired){
        this.$Msg.error('选项填写为必填')
        return false
      }
      if(notRequired){
        this.$Msg.error('当前题目为必答题')
        return false
      }
      //循环操作后，如果还留在当前题目，提示提交
      if(oldId == this.tId){
        if(this.view == 1){
          //预览时只需要提醒
          this.$message.info('没有下一题了')
          return false
        }
        this.$confirm("没有下一题了，是否直接提交", this.Language("提示"), {
          confirmButtonText: this.Language("确定"),
          cancelButtonText: this.Language("取消"),
          customClass: "new-alert-box",
          confirmButtonClass: "btn-custom-cancel",
          type: "info",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.useApiSaveInfoFn()
        }).catch(() => { })
      }else{
        this.prveIds.push(oldId) //跳到下一题时记录上一题的轨迹
      }
    },
    //添加meta
    addMeta(name, content){
      const meta = document.createElement('meta');
      meta.content = content;
      meta.name = name;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    //替换题目里面引用的部分
    reSubject(html){
      let nSubArr = this.rexFn(html) //正则匹配，获取引用结构 ${xxxxxx}
      if(nSubArr && nSubArr.length > 0){
        nSubArr.map((na)=>{
          let naar = na.substring(2, na.length-1)
          html = html.replace(na, '<span class="q_span" data-id="'+ naar +'"></span>')
        })
      }
      return html
    },
    //清除选项必填颜色
    clearRedFn(blankCnt, id){
      if(blankCnt){
        $('#opt_' + id).removeClass('optRed')
      }
    },
  }
};
</script>

<style scoped lang="scss">
  .qsPageBox{
    background: #f7f8fa;
    position: relative;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: auto;
  }
  .qsPage{
    width: 1030px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;
    padding: 0 15px;
    margin: 0 auto;
    height: fit-content;
    min-height: 100%;
    h1{
      padding: 30px;
      text-align: center;
    }
    >>> .el-radio-group{
      width: 100%;
    }
  }
  .qsPage.phoneView{
    width: 100%;
    padding: 0;
    h1{
      font-size: 22px;
    }
    .qsBottom button{
      width: 100%;
      font-size: 20px;
    }
  }
  
  .guideCnt{
    padding: 15px 30px;
    font-size: 16px;
    text-align: center;
  }
  .qsBox{
    padding: 30px 0;
  }
  .qsItem{
    padding: 15px;
  }
  .qsTitle{
    font-size: 16px;
    font-weight: bold;
  }
  .qsContent-item{
    margin: 20px 0 0;
    .el-radio{
      margin-right: 15px;
      >>> .el-radio__label{
        font-size: 16px;
        color: #535862;
        white-space: normal;
      }
    }
    .el-checkbox{
      margin-right: 15px;
      >>> .el-checkbox__label{
        font-size: 16px;
        color: #535862;
      }
    }
  }
  .qsBottom{
    padding: 15px;
  }
  .userBox{
    padding: 15px 15px 0;
  }
  .moreType{
    color: #989DAA;
    font-weight: normal;
  }
  .tips{
    font-size: 16px;
    padding: 30px 0;
  }
  .qsRed{
    border: red 1px solid;
    margin-top: -1px;
  }
  >>> .optRed{
    border: red 1px solid;
  }
  .agentBox{
    padding: 15px 15px 0;
    border-top: #e9e9e9 1px solid;
    border-bottom: #e9e9e9 1px solid;
  }
  >>> img{
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// qsPage.vue?35f37bea